export const SET_WARRANTY_NUMBER_CODE = 'SET_WARRANTY_NUMBER_CODE';
